// extracted by mini-css-extract-plugin
var _1 = "c7b08a";
export { _1 as "time" }
